export const formatCurrency = (amount: number): string => {
  if (!amount) {
    return "N0";
  }
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
  }).format(amount);
};
